import { initSelectStyling } from './core/utils/selectStyling.js';
import { initCssWatcher } from './core/utils/watchCss.js';
import { LoginApp } from './login/LoginApp.js';

const app = new LoginApp();
globalThis.app = app;


initSelectStyling();

initCssWatcher();
